export enum RuleTabEnum {
    CriteriaType,
    RuleTemplate,
    Rule,
}
